/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { Box, Dialog, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSetState } from "react-use";
import {
  createCandidateExperience,
  updateCandidateExperienceByID,
} from "../../../../graphql/mutations";
import { getCandidateByID } from "../../../../graphql/query";
import { toastError, toastSuccess, toFormatDate } from "../../../../shared/helpers";
import { useSetRecoilState } from "recoil";
import { globalLoadingAtom } from "../../../../shared/globalStates";

export default function Experiences({ open, setOpen, handleClose, data, index, setData }) {
  const client = useApolloClient();
  const [edit, setEdit] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [isCurrentExperience, setIsCurrentExperience] = useState(false);
  const [values, setValues] = useSetState({
    id: "",
    start_date: "",
    job_position: "",
    end_date: "",
    detail: "",
    company: "",
    is_current: isCurrentExperience,
  });

  useEffect(() => {
    if (open[1]) {
      setValues({
        id: data.Experiences[index].id,
        start_date: data.Experiences[index].start_date,
        job_position: data.Experiences[index].job_position,
        end_date: data.Experiences[index].end_date,
        detail: data.Experiences[index].detail,
        company: data.Experiences[index].company,
        is_current: data.Experiences[index].is_current,
      });
      setIsCurrentExperience(data.Experiences[index].is_current);
    } else {
      setValues({
        id: "",
        start_date: "",
        job_position: "",
        end_date: "",
        detail: "",
        company: "",
        is_current: false,
      });
      setIsCurrentExperience(false);
    }
  }, [data, open]);

  useEffect(() => {
    if (data.length !== 0) {
      handleEdited();
      return;
    }
    setEdit(false);
  }, [values]);
  const handleEdited = () => {
    if (
      !open[1] &&
      (!values.start_date ||
        (isCurrentExperience ? values.end_date : !values.end_date) ||
        !values.job_position ||
        !values.detail ||
        !values.company)
    ) {
      return setEdit(true);
    }
    if (data.Experiences === null) return setEdit(false);
    if (
      values.id !== data?.Experiences[index]?.id ||
      values.start_date !== data?.Experiences[index]?.start_date ||
      values.job_position !== data?.Experiences[index]?.job_position ||
      (values.is_current
        ? values.end_date === null && data.Experiences[index]?.end_date !== values.end_date
        : values.end_date !== data.Experiences[index]?.end_date) ||
      values.detail !== data?.Experiences[index]?.detail ||
      values.company !== data?.Experiences[index]?.company
    ) {
      setEdit(false);
    } else {
      setEdit(true);
    }
  };

  const handleSubmit = async () => {
    if (
      !values.company ||
      !values.detail ||
      (isCurrentExperience ? values.end_date !== null : !values.end_date) ||
      !values.job_position ||
      !values.start_date
    ) {
      setIsEmpty(true);
    } else {
      if (open[1]) {
        setLoading(true);
        const result = await updateCandidateExperienceByID(client, values);
        if (result.status !== "000") {
          toastError(result.errMsg);
          setOpen([false, false]);
        } else {
          toastSuccess("Edit Experiences Success");
          setIsCurrentExperience(false);
          setOpen([false, false]);
          getCandidateByID(client).then(setData);
        }
        setLoading(false);
      } else {
        setLoading(true);
        delete values.id;
        const result = await createCandidateExperience(client, values);
        if (result.status !== "000") {
          toastError(result.errMsg);
          setOpen([false, false]);
        } else {
          setIsCurrentExperience(false);
          toastSuccess("Add Experiences Success");
          setOpen([false, false]);
          getCandidateByID(client).then(setData);
        }
        setLoading(false);
      }
    }
  };

  const handleIsCurrentExperience = () => {
    setIsCurrentExperience(!isCurrentExperience);
    setValues({
      end_date: null,
      is_current: !isCurrentExperience,
    });
  };

  return (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        size="small"
        type="tertiary"
        onClick={() => {
          setOpen([true, false]);
          handleEdited();
        }}
        startIcon={<span className="material-icons"> add </span>}
        sx={{ fontSize: "14px" }}>
        Add Work Experience
      </Button>
      <Dialog open={open[0]} onClose={handleClose}>
        <Box>
          <Box p={2}>
            <Typography variant="h4">{open[1] ? "EDIT" : "ADD"} WORK EXPERIENCE</Typography>
          </Box>
          <Divider />
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <FormGroup
                  errorMessage={"Company name cannot be empty"}
                  isError={isEmpty && !values.company}
                  isRequired
                  showChildErrorSign
                  className=" font-size-main "
                  label="Company name">
                  <Input
                    id="company"
                    value={values?.company}
                    onChange={(e) =>
                      setValues({
                        company: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter Company name"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <FormGroup
                  errorMessage={"Position cannot be empty"}
                  isError={isEmpty && !values.company}
                  isRequired
                  showChildErrorSign
                  className="font-size-main"
                  label="Position">
                  <Input
                    id="job_position"
                    value={values?.job_position}
                    onChange={(e) =>
                      setValues({
                        job_position: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter position"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  errorMessage={"Start date cannot be empty"}
                  isError={isEmpty && !values.company}
                  isRequired
                  showChildErrorSign
                  className=" font-size-main"
                  label="Start Date">
                  <Input
                    id="start_date"
                    value={!values.start_date ? "" : toFormatDate(values.start_date)}
                    onChange={(e) =>
                      setValues({
                        start_date: e.target.value,
                      })
                    }
                    type="date"
                    placeholder="Enter start date"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  errorMessage={
                    Date.parse(values.start_date) > Date.parse(values.end_date)
                      ? "End date cannot be earlier than start date"
                      : "End date cannot be empty"
                  }
                  isError={
                    (isEmpty && !values.company) ||
                    Boolean(Date.parse(values.start_date) > Date.parse(values.end_date))
                  }
                  isRequired
                  showChildErrorSign
                  className="font-size-main"
                  label="End date">
                  <Input
                    id="end_date"
                    disabled={isCurrentExperience}
                    value={!values.end_date ? "" : toFormatDate(values.end_date)}
                    onChange={(e) =>
                      setValues({
                        end_date: e.target.value,
                      })
                    }
                    type="date"
                    placeholder="Enter end date"
                    required
                  />
                </FormGroup>
                <FormGroup
                  className="font-size-small justify-content-end"
                  placement="horizontal"
                  label="I'm currently working in this company">
                  <Checkbox
                    size="small"
                    checked={isCurrentExperience}
                    onClick={() => handleIsCurrentExperience()}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <FormGroup
                  errorMessage={"Job description cannot be empty"}
                  isError={isEmpty && !values.company}
                  isRequired
                  showChildErrorSign
                  className="font-size-main"
                  label="Job Description">
                  <Input
                    id="detail"
                    multiline
                    value={values?.detail}
                    onChange={(e) =>
                      setValues({
                        detail: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter job description"
                    required
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box p={2} textAlign="end">
            <Button
              onClick={() => setOpen([false, false])}
              variant="outlined"
              color="danger"
              style={{ margin: "0 10px" }}>
              Cancel
            </Button>
            <Button disabled={edit} onClick={handleSubmit} style={{ margin: "0 10px" }}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
